import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptBR from '../locales/pt-BR/translation.json';
import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';

const resources = {
  'pt-BR': {
    translation: ptBR,
  },
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en', 'es'],

    // Configuração para usar o texto em português como chave
    keySeparator: false,

    // Habilitar interpolação para variáveis
    interpolation: {
      escapeValue: false, // React já faz escape
    },

    // Detecção automática de idioma
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    // Debug apenas em desenvolvimento
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n;
